const cardFindHandler = (itemId) => (card) => card.id === itemId;

export default {
  activeDashboard: state => state.dashboards ? state.dashboards[state.activeDashboardIndex] : {},
  activeDashboardFilters: state => state.dashboardFilters,
  integrationToken: state => state.integrationToken,
  directAccess: (state, getters, rootState) => {
    const user = rootState.user?.user;

    if (!user) {
      return false;
    }

    return getters.activeDashboard.data?.users?.find(u => u.email === user.email);
  },
  cards: (state, getters) => {
    return getters.activeDashboard.data?.cards || [];
  },
  unsharableCards: (state, getters) => {
    return getters.activeDashboard.data.cards.filter(card => card.shareable === false);
  },
  pages: (state, getters) => {
    return getters.activeDashboard.data?.pages;
  },
  pagesChannels: (state, getters) => {
    return Array.from(new Set(getters.pages.map(page => page.channel)));
  },
  pagesIds: (state, getters) => {
    return Array.from(new Set(getters.pages.map(page => page.id)));
  },
  getCardByItemId: (state, getters, rootGetters) => (itemId) => {
    // cards could be loaded by dashboard or cards library
    return getters.cards.find(cardFindHandler(itemId)) ||
      rootGetters.cards.allowCards.find(cardFindHandler(itemId));
  },
  changes: (state, getters, rootState) => {
    const { changeControl } = getters.activeDashboard.data || {};

    if (changeControl) {
      return rootState.cards.changeLogs.filter(({ control }) => control > changeControl);
    }

    return rootState.cards.changeLogs;
  },
  activeGlobalFilter: (state, getters) => {
    return getters.activeDashboard.data?.globalFilter || null;
  },
  activeLanguage: (state, getters) => {
    return getters.activeDashboard.data?.language || null;
  },
  users: (state, getters) => {
    return getters.activeDashboard.data?.users || [];
  },
  isFirstEditor: (state, getters, rootState) => {
    const firstEditorMail = getters.activeDashboard.data?.users.find(user => user.email === rootState.user.user.email);
    return firstEditorMail.admin !== null && firstEditorMail.admin === true;
  },
  getCommandUrl: (state, getters) => {
    return getters.activeDashboard.data?.contracts?.commandUrl || '';
  },
  getBotKey: (state, getters) => {
    return getters.activeDashboard.data?.contracts?.key || '';
  },
  getIntegrationToken: (state, getters) => {
    return getters?.integrationToken || '';
  },
};
